module.exports = __webpack_public_path__ + "static/media/readingAndSpelling2d998664.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/categories/readingAndSpelling.svg
// module id = 1337
// module chunks = 0